import { isEqual } from 'lodash-es'
import { createContext, useContext, useEffect, useReducer, useRef } from 'react'

import { potentialKindSelector, selectedLocationsSelector } from './selectors'

const StateContext = createContext({})
const DispatchContext = createContext(() => {})

export const StateProvider = ({ reducer, initialState, onChange, children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const selectedLocations = selectedLocationsSelector(state)
  const initialized = useRef(false)
  const currentLocations = useRef(null)
  const shouldHandlePotentialKind = useRef(false)
  const potentialKind = potentialKindSelector(state)

  useEffect(() => {
    if (initialized.current && !isEqual(currentLocations.current, selectedLocations)) {
      onChange(Object.values(selectedLocations))
    } else {
      initialized.current = true
    }
    currentLocations.current = selectedLocations
  }, [onChange, selectedLocations])

  useEffect(() => {
    if (shouldHandlePotentialKind.current && !potentialKind) {
      onChange(Object.values(selectedLocations))
      shouldHandlePotentialKind.current = false
    }
    if (potentialKind) {
      shouldHandlePotentialKind.current = true
    }
  }, [onChange, selectedLocations, potentialKind])

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  )
}

export const useStateValue = () => useContext(StateContext)
export const useDispatchValue = () => useContext(DispatchContext)
